var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "q-modal",
    {
      attrs: { "content-css": { minWidth: "30vw", minHeight: "50vh" } },
      model: {
        value: _vm.open,
        callback: function($$v) {
          _vm.open = $$v
        },
        expression: "open"
      }
    },
    [
      _c(
        "q-modal-layout",
        [
          _c(
            "q-toolbar",
            { attrs: { slot: "header" }, slot: "header" },
            [
              _c("q-btn", {
                attrs: { flat: "", round: "", dense: "", icon: "clear" },
                on: { click: _vm.toggle }
              }),
              _c("q-toolbar-title", [_vm._v("\n        Signup\n      ")])
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "layout-padding" },
            [
              _c(
                "q-field",
                { staticClass: "q-pa-md" },
                [
                  _c("q-input", {
                    attrs: {
                      "float-label": "Email",
                      "error-messages": _vm.emailErrors,
                      value: _vm.signupForm.email,
                      required: ""
                    },
                    on: {
                      keyup: function($event) {
                        $event.stopPropagation()
                        _vm.updateSignupForm({
                          field: "email",
                          value: $event.target.value
                        })
                      },
                      input: function($event) {
                        _vm.$v.signupForm.email.$touch()
                      },
                      blur: function($event) {
                        _vm.$v.signupForm.email.$touch()
                      }
                    }
                  })
                ],
                1
              ),
              _c(
                "q-field",
                { staticClass: "q-pa-md" },
                [
                  _c("q-input", {
                    attrs: {
                      "float-label": "Password",
                      type: "password",
                      "error-messages": _vm.passwordErrors,
                      value: _vm.signupForm.password,
                      required: ""
                    },
                    on: {
                      keyup: function($event) {
                        $event.stopPropagation()
                        _vm.updateSignupForm({
                          field: "password",
                          value: $event.target.value
                        })
                      },
                      input: function($event) {
                        _vm.$v.signupForm.password.$touch()
                      },
                      blur: function($event) {
                        _vm.$v.signupForm.password.$touch()
                      }
                    }
                  })
                ],
                1
              ),
              _c(
                "q-field",
                { staticClass: "q-pa-md" },
                [
                  _c("q-input", {
                    attrs: {
                      "float-label": "Confirm Password",
                      type: "password",
                      "error-messages": _vm.confirmPasswordErrors,
                      value: _vm.signupForm.confirmPassword,
                      required: ""
                    },
                    on: {
                      keyup: function($event) {
                        $event.stopPropagation()
                        _vm.updateSignupForm({
                          field: "confirmPassword",
                          value: $event.target.value
                        })
                      },
                      input: function($event) {
                        _vm.$v.signupForm.confirmPassword.$touch()
                      },
                      blur: function($event) {
                        _vm.$v.signupForm.confirmPassword.$touch()
                      }
                    }
                  })
                ],
                1
              )
            ],
            1
          ),
          _c(
            "q-toolbar",
            { attrs: { slot: "footer" }, slot: "footer" },
            [
              _c("q-toolbar-title"),
              _c("q-btn", {
                attrs: {
                  color: "primary",
                  label: "Submit",
                  disabled: _vm.invalid
                },
                nativeOn: {
                  click: function($event) {
                    _vm.submitSignupForm()
                  }
                }
              })
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }